import { render, staticRenderFns } from "./NewsFeedItem.vue?vue&type=template&id=69de8208"
import script from "./NewsFeedItem.vue?vue&type=script&lang=js"
export * from "./NewsFeedItem.vue?vue&type=script&lang=js"
import style0 from "./NewsFeedItem.vue?vue&type=style&index=0&id=69de8208&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports